<nav #navbar class="navbar navbar-expand-lg navbar-absolute">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button mat-raised-button type="button" (click)="minimizeSidebar()"
                class="btn btn-just-icon btn-white btn-fab btn-round"
                [attr.aria-expanded]="!isSidebarMinimized"
                [attr.aria-label]="(isSidebarMinimized ? 'MENU_SHARED.EXPAND_SIDEBAR' : 'MENU_SHARED.COLLAPSE_SIDEBAR') | translate"
                [attr.title]="(isSidebarMinimized ? 'MENU_SHARED.EXPAND_SIDEBAR' : 'MENU_SHARED.COLLAPSE_SIDEBAR') | translate">
          <svg class="sidebar-toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4" width="18" height="16" rx="2"></rect>
            <path d="M9 4v16"></path>
            <path [attr.d]="isSidebarMinimized ? 'M13 9l3 3-3 3' : 'M16 9l-3 3 3 3'"></path>
          </svg>
        </button>
      </div>
      <div class="navbar-title"><a class="navbar-brand" [routerLink]="getPath().split('?')[0]" queryParamsHandling="preserve"> {{getTitle() | translate}}<span [innerHTML]="getTitleComplement()"></span></a></div>
    </div>
    <div class="header-actions" id="navigation">
      <button mat-button class="navbar-toggler btn-no-ripple" type="button" (click)="sidebarToggle()">
        <span class="sr-only">{{'REDESIGN.UI.TOGGLE_NAV' | translate}}</span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
        <span class="navbar-toggler-icon icon-bar"></span>
      </button>

      <app-language-switch-item></app-language-switch-item>
      <a class="profile-menu-trigger" [routerLink]="getMyAccountRoute()"
              [class.profile-active]="isMyCompanyAccountLink() || isMyForwarderAccountLink()"
              [attr.aria-current]="isMyCompanyAccountLink() || isMyForwarderAccountLink() ? 'page' : null"
              [attr.aria-label]="'MENU_COMPANY.MY_ACCOUNT' | translate">
        <img class="profile-avatar"
             [appUserAvatar]="globals.avatar ? globals.getEnvironment().baseApiUrl + 'files/' + globals.avatar : null"
             [avatarSeed]="globals.userId"
             alt="">
      </a>
    </div>
  </div>
</nav>
